import React, { useMemo, useRef, useState } from "react";

import { ACTIVE_MODULE } from "app/_constants/constant";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import {
  alertApis,
  emailApis,
  systemNotificationFilterFieldsAlert,
  systemNotificationFilterFieldsEmail,
} from "./Constant";
import TableWithServerSide from "app/Components/TableWithServerSide/TableWithServerSide";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import { isArray } from "lodash";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import EmailFilter from "./filters/EmailFilter";
import AlertFilter from "./filters/AlertFilter";
import { excelExport } from "app/_services/ehs/ehsBlockIp";
import { saveAs } from "file-saver";
import { saveAsExcel } from "app/_helpers/exportExcel";
import { excelExportAlert, excelExportEmail } from "app/_services/ehs/ehsExcelExport";
import { Link } from "react-router-dom";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FiEye } from "react-icons/fi";
import { Button, Col, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { capitalizeName } from "app/_helpers/helper";
// import { Prev } from "react-bootstrap/lib/Pagination";
// import { Button } from "react-bootstrap/lib/InputGroup";
const SystemNotifications = () => {
  const [showFilterEmail, setShowFilterEmail] = useState(false);
  const [array, setArray] = useState([]);
  const [dot, setDot] = useState("");
  const [showModalEmail, setShowModalEmail] = useState(false);
  const [tab, setTab] = useState(1);
  const [modalDataEmail, setModalDataEmail] = useState({});

  const [showModalAlert, setShowModalAlert] = useState(false);
  const [modalDataAlert, setModalDataAlert] = useState({});

  const [showFilterAlert, setShowFilterAlert] = useState(false); //true
  const [filterFormEmail, setFilterFormEmail] = useState({
    // eventType: "",
    // dateRange: { startDate: null, endDate: null },
    // sent: "",
  });
  const [filterForAlert, setFilterFormAlert] = useState({
    // eventType: "",
    // dateRange: { startDate: null, endDate: null },
    // sent: "",
  });

  const tableContainerRef = useRef(null);

  const excelExportFuntion = async () => {
    const res = await excelExportEmail();
    if (res?.status === "success") {
      let finalData = res?.data?.map((d) => ({ ...d, eventType: d?.event }));
      saveAsExcel(finalData, sortableColumnEmail, res?.fileName);
    }
  };

  const excelExportAlertFuntion = async () => {
    const res = await excelExportAlert();
    if (res?.status === "success") {
      saveAsExcel(res?.data, sortableColumnAlert, res?.fileName);
    }
  };

  // ******** useMemo ******
  const sortableColumnEmail = useMemo(() => {
    let column = [
      {
        dataField: "sid",
        text: "S.No.",
        // sort: true,
      },
      // {
      //   dataField: "eventType",
      //   text: "Event Type",
      // sort: true,
      // },

      {
        dataField: "date",
        text: "Date",
        // sort: true,
        formatter: (updatedAt, row) => {
          if (row?.sent === 1) return DDMMYYYYHHMMAFormat(row.updatedAt);
          else {
            return "";
          }
        },
      },
      {
        dataField: "to",
        text: "To",
        // sort: true,
        formatter: (cell, row) => {
          // return isArray(row?.dataJson?.headers?.CC)
          //   ? row?.dataJson?.headers?.CC?.join(", ")
          //   : "";

          if (isArray(row?.dataJson?.headers?.TO)) {
            if (row?.dataJson?.headers?.TO.length <= 2)
              return row?.dataJson?.headers?.TO?.join(", ") + " ";
            else return row?.dataJson?.headers?.TO?.splice(0, 2).join(", ") + " ...";
          } else {
            return row?.dataJson?.headers?.TO + " ...";
          }
        },

        // formatter: (cell, row) => {
        //   console.log("row1999", row);

        //   if (isArray(row?.dataJson?.headers?.TO)) setArray(row?.dataJson?.headers?.TO);
        //   if (array.length >= 2) {
        //     setArray(array.slice(0, 2));
        //     setDot("...");
        //   }
        //   return <>"anmol"</>;

        //   // return (
        //   //   <>
        //   //     <div className="columnWidthSmall">
        //   //       <span
        //   //         title={row?.contractors.contractorLegalEntity}
        //   //         className="icons text-cyanBlue"
        //   //       >
        //   //         {row?.contractors.contractorEntityCode}
        //   //       </span>
        //   //     </div>
        //   //   </>
        //   // );
        // },
      },

      // {
      //   dataField: "dataJson.headers.CC",
      //   text: "CC",
      //   sort: true,
      //   formatter: (cell, row) => {
      //     return isArray(row?.dataJson?.headers?.CC)
      //       ? row?.dataJson?.headers?.CC?.join(", ")
      //       : "";
      //   },
      // },

      {
        dataField: "subject",
        text: "Subject",
        // sort: true,
        // excelWith: 90,
        formatter: (cell, row) => {
          return row?.dataJson?.subject;
        },
      },
      {
        dataField: "sentStatus",
        text: "Sent Status",
        // sort: true,
        formatter: (cell, row) => {
          if (row?.sent === 1) return "Yes";
          else {
            return "No";
          }
        },
      },
      {
        dataField: "eventType",
        text: "Event",
      },

      {
        dataField: "type",
        text: "Type",
        // sort: true,
        // formatter: (cell, row) => {
        //   console.log("row29", row);
        //   if (row?.sent === 1) return "Yes";
        //   else {
        //     return "No";
        //   }
        // },
      },
      {
        dataField: "action",
        text: "Action",
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">View</Tooltip>}
              >
                <span
                  className="icons text-cyanBlue"
                  onClick={() => {
                    // setShowManageModal(true);
                    // setViewModal(true);
                    setShowModalEmail(true);
                    setModalDataEmail(row);
                  }}
                >
                  <FiEye />
                </span>
              </OverlayTrigger>
            </div>
          );
        },
      },
    ];
    return column;
  }, []);

  const sortableColumnAlert = useMemo(() => {
    let column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "date",
        text: "Date",
        sort: true,
        formatter: (cell, row) =>
          row?.createdAt ? DDMMYYYYFormat(row?.createdAt) : row?.createdAt,
      },
      {
        dataField: "userName",
        text: "User Name",
        sort: true,
        formatter: (cell, row) => {
          return capitalizeName(
            row?.users ? row.users.firstName + " " + row.users.lastName : ""
          );
        },
      },
      // {
      //   dataField: "event",
      //   text: "Event Type",
      //   sort: true,
      // },
      {
        dataField: "notificationMessage",
        text: "Notification Message",
        sort: true,
      },
      // {
      //   dataField: "navInfo",
      //   text: "Nav Information",
      //   sort: true,
      // },
      {
        dataField: "readStatus",
        text: "Read Status",
        sort: true,
        formatter: (cell, row) => {
          if (row?.readStatus === 1) return "Yes";
          else {
            return "No";
          }
        },
      },
      {
        dataField: "event",
        text: "Event",
        // sort: true,
        // formatter: (cell, row) => {

        //   if (row?.readStatus === 1) return "Yes";
        //   else {
        //     return "No";
        //   }
        // },
      },

      { dataField: "type", text: "Type" },

      {
        dataField: "action",
        text: "Action",
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">View</Tooltip>}
              >
                <span
                  className="icons text-cyanBlue"
                  onClick={() => {
                    // setShowManageModal(true);
                    // setViewModal(true);
                    // setShowModal(true);
                    // setModalData(row);
                    setShowModalAlert(true);
                    setModalDataAlert(row);
                  }}
                >
                  {<FiEye />}
                </span>
              </OverlayTrigger>
            </div>
          );
        },
      },
    ];
    return column;
  }, []);

  const onChangeEmail = ({ target: { name, value, key } }) => {
    setFilterFormEmail((prev) => {
      // if (key) return { ...prev, [key]: { ...prev[key], [name]: value } };
      if (key) return { ...prev, [name]: value };
      return { ...prev, [name]: value };
    });
  };
  const onChangeAlert = ({ target: { name, value, key } }) => {
    //console.log('+++++====', name, key);
    setFilterFormAlert((prev) => {
      // if (key) return { ...prev, [key]: { ...prev[key], [name]: value } };
      if (key) return { ...prev, [name]: value };
      return { ...prev, [name]: value };
    });
  };
  const onResetEmail = () =>
    setFilterFormEmail({
      // eventType: "",
      // sent: "",
      // dateRange: { startDate: null, endDate: null },
    });
  const onResetALert = () =>
    setFilterFormAlert({
      userName: "",

      // eventType: "",
      // sent: "",
      // dateRange: { startDate: null, endDate: null },
    });
  const updateTab = (n) => {
    setTab(n);
  };
  const tableToolbarBeforeViewEmail = () =>
    tab === 1 &&
    showFilterEmail && (
      <EmailFilter
        fields={systemNotificationFilterFieldsEmail}
        setForm={setFilterFormEmail}
        form={filterFormEmail}
        onChange={onChangeEmail}
        onReset={onResetEmail}
      />
    );
  const tableToolbarBeforeViewAlert = () =>
    tab === 2 &&
    showFilterAlert && (
      <AlertFilter
        fields={systemNotificationFilterFieldsAlert}
        setForm={setFilterFormAlert}
        form={filterForAlert}
        onChange={onChangeAlert}
        onReset={onResetALert}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Admin Panel", path: "#" },
          {
            name: "System Notifications",
            path: "#",
          },
        ]}
        module={ACTIVE_MODULE.training}
      />
      <div className="healthSafetyEnvironmentWrapper">
        <div className="healthSafetyEnvironmentWrapper incidentMenu">
          <div className="hseMenuLinks card pointer" style={{ minHeight: 75 }}>
            <a
              className={`${tab === 1 ? "active" : ""}`}
              href
              onClick={() => updateTab(1)}
            >
              Notification/Alerts Emails
            </a>
            <a
              className={`${tab === 2 ? "active" : ""}`}
              href
              onClick={() => updateTab(2)}
            >
              Notification/Alerts (on System)
            </a>
          </div>
        </div>
        <div className="p-2">
          <div className="card p-3 mt-3" ref={tableContainerRef}>
            <div className="simple-card-title">
              {(tab === 1 && <h3 className="text-capitalize mb-1">Emails</h3>) || (
                <h3 className="text-capitalize mb-1">Alerts</h3>
              )}
              {/* {showFilterBtn && <FilterBtn setShowFilter={setShowFilter} />} */}
              {tab === 1 && <FilterBtn setShowFilter={setShowFilterEmail} />}
              {tab === 2 && <FilterBtn setShowFilter={setShowFilterAlert} />}
            </div>
            <>
              {tab === 1 && (
                <TableWithServerSide
                  title="Emails"
                  tableBeforeSearch={tableToolbarBeforeViewEmail}
                  columns={sortableColumnEmail}
                  apis={emailApis}
                  tableName="emails"
                  searchFormKeys={filterFormEmail}
                  hideSidColumn
                  hideActionsColumn
                  hideAddButton
                  excelExport={excelExportFuntion}
                />
              )}
              {tab === 2 && (
                <TableWithServerSide
                  title="Alerts"
                  tableBeforeSearch={tableToolbarBeforeViewAlert}
                  columns={sortableColumnAlert}
                  apis={alertApis}
                  searchFormKeys={filterForAlert}
                  tableName="notifications"
                  hideSidColumn
                  hideActionsColumn
                  hideAddButton
                  excelExport={excelExportAlertFuntion}
                />
              )}
            </>
          </div>
        </div>
      </div>
      <Modal size={"lg"} show={showModalEmail} onHide={() => setShowModalEmail(false)}>
        <Modal.Header>
          <Modal.Title>View </Modal.Title>
        </Modal.Header>

        <div className="col-lg-12">
          <div className="card mt-4 mb-3" style={{ overflow: "visible" }}>
            <div className="card-body">
              <div
                className="addressSmlSec"
                style={{ paddingLeft: "10px", paddinTop: "0", borderTop: "0" }}
              >
                <Row>
                  <Row>
                    <Col md={6} className="drilingView-bx">
                      <h5>To</h5>
                      <p>
                        {isArray(modalDataEmail?.dataJson?.headers?.TO)
                          ? modalDataEmail?.dataJson?.headers?.TO?.map((ele) => ele) + " "
                          : modalDataEmail?.dataJson?.headers?.TO + " "}
                      </p>
                    </Col>
                    <Col md={6} className="drilingView-bx">
                      <h5>Date Time</h5>
                      <p>{DDMMYYYYHHMMAFormat(modalDataEmail?.createdAt)}</p>
                    </Col>
                  </Row>
                  <Col md={12} className="drilingView-bx">
                    <h5>Subject</h5>
                    <p>{modalDataEmail?.dataJson?.subject}</p>
                  </Col>

                  {isArray(modalDataEmail?.dataJson?.headers?.CC).length > 0 && (
                    <Col md={12} className="drilingView-bx">
                      <h5>CC</h5>
                      <p>
                        {isArray(modalDataEmail?.dataJson?.headers?.CC)
                          ? modalDataEmail?.dataJson?.headers?.CC?.map((ele) => ele) + " "
                          : ""}
                      </p>
                    </Col>
                  )}

                  <Col md={12} className="drilingView-bx">
                    <h5>Email body</h5>
                    {/* <p>{modalData?.dataJson?.dataBody?.INTRO}</p> */}
                    {/* <div
                      dangerouslySetInnerHTML={modalData?.dataJson?.dataBody?.INTRO}
                    ></div> */}
                    <br />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: modalDataEmail?.dataJson?.dataBody?.INTRO,
                      }}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalEmail(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal size={"lg"} show={showModalAlert} onHide={() => setShowModalAlert(false)}>
        <Modal.Header>
          <Modal.Title>View </Modal.Title>
        </Modal.Header>

        <div className="col-lg-12">
          <div className="card mt-4 mb-3" style={{ overflow: "visible" }}>
            <div className="card-body">
              <div className="addressSmlSec" style={{ paddinTop: "0", borderTop: "0" }}>
                <Row>
                  <Col md={6} className="drilingView-bx">
                    <h5>User Name</h5>
                    <p>
                      {capitalizeName(
                        modalDataAlert?.users?.firstName +
                          " " +
                          modalDataAlert?.users?.lastName
                      )}
                    </p>
                  </Col>

                  <Col md={6} className="drilingView-bx">
                    <h5>Notification Message</h5>
                    <p>{modalDataAlert?.notificationMessage}</p>
                  </Col>
                  <Col md={6} className="drilingView-bx">
                    <h5>Date Time</h5>
                    <p>{DDMMYYYYHHMMAFormat(modalDataAlert?.createdAt)}</p>
                  </Col>
                  <Col md={6} className="drilingView-bx">
                    <h5>Event</h5>
                    <p>{modalDataAlert?.event}</p>
                  </Col>

                  <Col md={6} className="drilingView-bx">
                    <h5>Read Status</h5>
                    <p>{modalDataAlert?.readStatus === 1 ? "Yes" : "No"}</p>
                  </Col>
                  <Col md={6} className="drilingView-bx">
                    <h5>Type</h5>
                    <p>{modalDataAlert?.type}</p>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalAlert(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default SystemNotifications;
